import { createSelector } from 'reselect';
import compact from 'lodash/compact.js';
import values from 'lodash/values.js';
import productInfoSelector from './productInfoSelector';
import getFulfillmentOption, { hasBopis, hasBoss } from '../../utils/getFulfillmentOption';

const productsForCartSelector = createSelector(
  productInfoSelector,
  (productInfo) => {
    const {
      DefaultProduct, // discard "null" product
      base,
      primary,
      ...rest
    } = productInfo;

    // We only check availability of primary, and assume others are available
    // run down of things to check:
    //  - combined BOPIS (available and in stock)
    //  - primary BOPIS (available and in stock)
    //  - combined BOSS
    //  - primary any
    //  - base any
    let products = [];

    // TODO: review this logic, see if it still
    // makes sense with new fulfillment tiles.
    if (base && hasBopis(base)) {
      products = [base];
    } else if (primary && hasBopis(primary)) {
      products = [primary, ...values(rest)];
    } else if (base && hasBoss(base)) {
      products = [base];
    } else if (primary && getFulfillmentOption(primary)) {
      products = [primary, ...values(rest)];
    } else if (base && getFulfillmentOption(base)) {
      products = [base];
    }

    return compact(products);
  },
);

export default productsForCartSelector;
